import React, { PropTypes } from 'react'
import BaseModal from '../base-modal'

const constraints = {
  'width': '415px',
  'minWidth': '415px'
}

const ForgotPasswordSuccessModal = ({handleClose, email}) => (
  <BaseModal
    onClose={handleClose}
    title='Forgot Your Password?'
    constraints={constraints}
    contentClassName='forgot-password-success-modal'>
    <p className='message'>
      Instructions on how to reset your password have been sent to {email}
    </p>
    <button className='close-button' onClick={handleClose}>Close</button>
  </BaseModal>
)

ForgotPasswordSuccessModal.propTypes = {
  handleClose: PropTypes.func.isRequired,
  email: PropTypes.string.isRequired
}

export default ForgotPasswordSuccessModal



// WEBPACK FOOTER //
// ./src/components/login/forgot-password-success.js